export default "__VITE_ASSET__BJqt7wgl__"